import { GraphQL } from 'app/graphql';
import moment from 'moment-timezone';
import _ from 'lodash';

export enum MediaType {
  Channel = "channelID",
  ChannelStream = "channelStreamID",
}
export type MediaTypeEnum = Record<MediaType, string>;


export class Schedule {
  MediaID: number;
  LangModelID;
  Days;
  Period;
  SpleeterEnabled;
  SpleeterVAD;
  Title;
  Split;

  private startTime: moment.Moment;
  private dur;
  private endTime;
  private date;
  private dow;
  private data: GraphQL.UserSchema.Schedule;

  static map(data: GraphQL.UserSchema.Schedule[], mType: MediaType): Schedule[] {
    const res = [];
    let sched: Schedule;
    for (const gqlSched of data) {
      sched = new Schedule(gqlSched, mType);
      if (sched.MediaID > 0) {
        res.push(sched);
      }
    }
    return res;
  }

  getData() {
    return this.data;
  }

  Next(): string {
    let m: moment.Moment;
    if (moment(this.date).isValid()) {
      m = moment(this.date).set({
        h: this.startTime.hour(),
        m: this.startTime.minute()
      });
    } else if ((this.dow || []).length === 0) {
      return 'Nekad';
    } else if (this.is247()) {
      return '24/7';
    } else {
      m = moment(this.startTime);
      if (m.isBefore()) {
        m.add(1, 'day');
      }
      for (let i = 7; i > 0; i--) {
        if ((this.dow || [])[m.isoWeekday()]) {
          break;
        }
        m.add(1, 'day');
      }
    }
    return `${m.format('LLL')} (${m.fromNow()})`;
  }

  is247() {
    return _.isEqual(_.range(1, 7 + 1), this.dow) &&
      this.startTime.format('HH:mm') === '00:00' &&
      this.dur.asMinutes() === 1439;
  }

  spleeterDesc(): string {
    if (!this.SpleeterEnabled) {
      return 'Disabled';
    } else if (this.SpleeterVAD == 0) {
      return 'Only vocals';
    }
    return `${this.SpleeterVAD}`;
  }

  constructor(data: GraphQL.UserSchema.Schedule, mType: MediaType) {
    this.MediaID = _.get(data, mType, 0) as number;
    this.data = data;
    this.dow = data.dow;
    this.startTime = moment(`${data.time}`, 'HH:mm:ss.SSS');
    this.dur = moment.duration(data.duration, 'minutes');
    this.endTime = moment(this.startTime).add(this.dur);
    this.date = moment(data.date);
    let nextDayPrefix = '';
    if (this.startTime.isSame(this.endTime, 'date') === false) {
      nextDayPrefix = '(next day) ';
    }
    this.Period = `${this.startTime.format('HH:mm')} - ${nextDayPrefix}${this.endTime.format('HH:mm')} (${this.dur.humanize()})`;
    this.LangModelID = data.langModelID;
    this.SpleeterEnabled = data.spleeter >= 0;
    this.SpleeterVAD = data.spleeter;
    this.Title = data.title;
    this.Split = data.split;
    if (data.date != null) {
      this.Days = moment.tz(`${data.date} ${data.time}`, data.timezone).format('LL');
    } else {
      this.Days = (this.dow || []).map(day => moment(day, 'E').format('ddd')).join(', ');
    }
  }
}